import { useContext } from 'react';
import { useValueStore } from '@dtvgo/value-store';
import { PlayerStateContext, PlayerBufferingContext, PlayerSeekingContext, PlayerViewModeContext, PlayerTimeContext, PlayerCurrentTimeContext, PlayerDurationContext, PlayerMaxTimeShiftContext, PlayerVolumeContext, AudioTracksContext, SubtitleTracksContext, PlayerActionsContext } from './contexts.js';
import './constants.js';
import './utils.js';

function useValueStoreContext(context) {
  return useValueStore(useContext(context));
}
function usePlayerState() {
  return useValueStoreContext(PlayerStateContext);
}
function useBuffering() {
  return useValueStoreContext(PlayerBufferingContext);
}
function useSeeking() {
  return useValueStoreContext(PlayerSeekingContext);
}
function usePlayerViewMode() {
  return useValueStoreContext(PlayerViewModeContext);
}
function usePlayerTime() {
  return useValueStoreContext(PlayerTimeContext);
}
function usePlayerCurrentTime() {
  return useValueStoreContext(PlayerCurrentTimeContext);
}
function usePlayerDuration() {
  return useValueStoreContext(PlayerDurationContext);
}
function usePlayerMaxTimeShift() {
  return useValueStoreContext(PlayerMaxTimeShiftContext);
}
function usePlayerVolume() {
  return useValueStoreContext(PlayerVolumeContext);
}
function useAudioTracks() {
  return useValueStoreContext(AudioTracksContext);
}
function useSubtitleTracks() {
  return useValueStoreContext(SubtitleTracksContext);
}
function usePlayerActions() {
  return useContext(PlayerActionsContext);
}

export { useAudioTracks, useBuffering, usePlayerActions, usePlayerCurrentTime, usePlayerDuration, usePlayerMaxTimeShift, usePlayerState, usePlayerTime, usePlayerViewMode, usePlayerVolume, useSeeking, useSubtitleTracks, useValueStoreContext };
//# sourceMappingURL=hooks.js.map
